const BASE_URLS = {
  SKELETOR: import.meta.env.PROD
    ? import.meta.env.VITE_SKELETOR_API_URL
    : `${window.location.origin}/skeletor`,
  RAMMAN: import.meta.env.PROD
    ? import.meta.env.VITE_RAMMAN_API_URL
    : `${window.location.origin}/ramman`,
  RIOBLAST: import.meta.env.PROD
    ? import.meta.env.VITE_RIOBLAST_API_URL
    : `${window.location.origin}/rioblast`,
  DRAGOON: import.meta.env.PROD
    ? import.meta.env.VITE_DRAGOON_API_URL
    : `${window.location.origin}/dragoon`,
  FISTO: import.meta.env.PROD
    ? import.meta.env.VITE_FISTO_API_URL
    : `${window.location.origin}/fisto`,
  API_GATEWAY: import.meta.env.PROD
    ? import.meta.env.VITE_API_GATEWAY_URL
    : window.location.origin,
};

export { BASE_URLS };
